import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { _StrategicObjetive } from '../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { SubMarcroProccesEditor } from '../MacroProcess/MacroProccesEditors/SubMarcroProcces.editor';
import { MarcroProccesEditor } from '../MacroProcess/MacroProccesEditors/MacroProcess.editor';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const StrategicObjectiveEditortwo = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_StrategicObjetive)
    const [id, setID] = useState(null);
    const [IdmacroProcess, setIdmacroProcess] = useState<number>(null)
    const [IdSubProcess, setIdSubProcess] = useState<number>(null)
    const modal = useModal("Objetivos Estratégicos", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDStrategicObjective == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getStrategicObjectiveCatalog(IdmacroProcess, IdSubProcess).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDStrategicObjective', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Macro Proceso', property: 'MacroProcessName', visible: true },
        { title: 'Sub Proceso', property: 'SubProcessName', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Objetivos Estratégicos"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <MarcroProccesEditor idSelector={IdmacroProcess} onChange={(e) => { setIdmacroProcess(e) }} />
                    </div>
                    <div className="col-md-6">
                        <SubMarcroProccesEditor label="SubProceso" macroProcess={IdmacroProcess} idSelector={IdSubProcess} onChange={(e) => { setIdSubProcess(e) }} />
                    </div>
                    <div className="col-md-6">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Consultar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDStrategicObjective); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}